// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const golisopod: PokeData = {
  "id": 768,
  "name": "golisopod",
  "height": 20,
  "weight": 1080,
  "base_experience": 186,
  "types": [
    PokeType.BUG,
    PokeType.WATER
  ],
  "api_moves": [
    "swords-dance",
    "sand-attack",
    "pin-missile",
    "defense-curl",
    "slash",
    "spite",
    "fury-cutter",
    "rock-smash",
    "iron-defense",
    "mud-shot",
    "sucker-punch",
    "bug-bite",
    "struggle-bug",
    "razor-shell",
    "first-impression",
    "liquidation"
  ],
  "moves": [
    "pin-missile",
    "rock-smash",
    "mud-shot",
    "bug-bite",
    "liquidation",
    "leech-steal",
    "bubble-beam",
    "lunge",
    "brine",
    "life-dew",
    "water-spout",
    "bug-buzz",
    "pounce"
  ],
  "evolution_chain": {
    "id": 396,
    "item": null,
    "species": [
      {
        "name": "wimpod",
        "order": 767,
        "types": [
          PokeType.BUG,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "golisopod",
        "order": 768,
        "types": [
          PokeType.BUG,
          PokeType.WATER
        ],
        "evolves_from_species_id": 767,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 146,
    "speed": 62,
    "ability_power": 192
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
